'use client';
import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  Input,
  Select,
  Button,
  Avatar,
  Space,
  Tabs,
  Pagination,
} from 'antd';
import CenterLayout from '@/components/layout/center-layout';

const { TabPane } = Tabs;
export default function Index() {

  const [Loading, setLoading] = useState(false);
  const [pageWhere, setPageWhere] = useState({
    page: 1,
    pageSize: 5,
    total:0
  });

  function onPageChange(){}
  return (
          <div className='exchange'>
      {/* 筛选区域 */}
      <Card style={{ marginTop: '16px' }}>
        <div className=" flex  items-center justify-between">
          <div className="flex items-center gap-10">
            <span className='cursor-pointer text-main'>默认</span>

            <span className='cursor-pointer'>热门商品</span>

            <span className='cursor-pointer'>新上架</span>
              <div className='mx-4'>
              <span>积分：</span>
              <Input
                style={{ width: 100 }}
                placeholder="最小值"
              />
              <span className='mx-2'>-</span>
              <Input
                style={{ width: 100 }}
                placeholder="最大值"
              />

              </div>

              <div>
              <span>商品分类：</span>
              <Select
                defaultValue="全部"
                style={{ width: 120 }}
              >
                <Select.Option value="all">全部</Select.Option>
              </Select>
              </div>

          </div>
          <div className='max-lg:hidden'>共100个商品商品</div>
        </div>
      </Card>

      {/* 商品列表 */}
      <div className='grid grid-cols-4  gap-2 max-lg:grid-cols-3 my-5 '>
      {Array(10)
          .fill(null)
          .map((_, index) => (
            <Card
            key={index}
            >
             <img
                  alt="DFC联轴器"
                  src="/image/36.png"
                  className='w-full h-full'
                />
              <div className='pb-1'>DFC联轴器</div>
              <div className='text-[#dcdcdc] border-b-[1px] border-[#dcdcdc] pb-1'>参考价：224488元</div>
              <div className='flex items-center' style={{ color: '#ff6000', marginTop: '8px' }}>
               <img src="/image/33.png" alt="" className='w-8 h-8   ' /><span>599760 积分</span>
              </div>
              <Button
                type="primary"
                block
                style={{ marginTop: '8px' }}
              >
                立即兑换
              </Button>
            </Card>
          ))}
      </div>

           
          <div className="mt-1 py-1 bg-white">
            <Pagination
              defaultCurrent={pageWhere.page}
              total={pageWhere.total}
              defaultPageSize={pageWhere.pageSize}
              onChange={onPageChange}
              className="text-right"
            />
          </div>
       
    </div>


  );
}
